import { render, staticRenderFns } from "./DialogVideoCallFullScreen.vue?vue&type=template&id=274ac444&scoped=true&"
import script from "./DialogVideoCallFullScreen.vue?vue&type=script&lang=ts&"
export * from "./DialogVideoCallFullScreen.vue?vue&type=script&lang=ts&"
import style0 from "./DialogVideoCallFullScreen.vue?vue&type=style&index=0&id=274ac444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274ac444",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDialog,VImg,VRow,VSpacer})
